import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import image13 from  "../../Images/sweepydo_image13.jpg";


function PrivacyPolicy() {
  return (
    <>
    
      <section
    
className="d-flex flex-column flex-md-row align-items-center justify-content-between"
style={{
  minHeight: "260px",
  // height: "220px",
  
  color: "#121313",
  padding: "20px clamp(20px, 5vw, 60px)",
  backgroundImage: `url(${image13})`,
  backgroundSize: "cover",
  backgroundPosition: "center top",
  backgroundRepeat: "no-repeat",
  backgroundColor: "#f5f5f5",
  position: "relative",
  overflow: "hidden",
  fontFamily: "'Montserrat', sans-serif",
  height: "450px",
}}
>
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(255, 255, 255, 0.45)",
            zIndex: 0,
          }}
        ></div>

        <div
          style={{
            position: "relative",
            zIndex: 1,
            flex: 1,
            textAlign: "center",
            marginBottom: "10px",
          }}
        >
          <h1
            className="fw-bold"
            style={{
              fontSize: "clamp(34px, 4vw, 58px)",
              margin: 0,
              fontWeight: "700",
            }}
          >
            Privacy Policy
          </h1>
        </div>

        <div
          style={{
            position: "relative",
            zIndex: 1,
            flex: 1,
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: "clamp(14px, 1.2vw, 16px)",
              color: "#555",
              fontWeight: "500",
            }}
          >
            <span
              style={{ cursor: "pointer", color: "#6A20Af" }}
              onClick={() => (window.location.href = "/")}
            >
              Home
            </span>{" "}
            &gt; <span>Privacy Policy</span>
          </div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section style={{ padding: "60px 15px", backgroundColor: "#f9f9f9" }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={10} lg={9}>

              <div style={{ background: "#fff", padding: "30px", borderRadius: "12px" }}>

                <h2 style={{ fontWeight: "700", marginBottom: "10px" }}>
                   Privacy Policy for Sweepydo
                </h2>

                <p style={{ color: "#666" }}>
                  <strong>Effective Date:</strong> 05/05/2026
                </p>

                <p style={{ color: "#444" }}>
                  Sweepydo (“we”, “our”, or “us”) operates the Sweepydo mobile application and services.
                  This Privacy Policy explains how we collect, use, and protect your information.
                </p>

                <hr />

                <h4>1. Information We Collect</h4>
                <p><b>a) Personal Information</b></p>
                <ul>
                  <li>Name</li>
                  <li>Phone number</li>
                  <li>Email address</li>
                  <li>Home address</li>
                </ul>

                <p><b>b) Usage Information</b></p>
                <ul>
                  <li>App activity</li>
                  <li>Booking history</li>
                  <li>Device information</li>
                </ul>

                <p><b>c) Location Data</b></p>
                <p>Used for service availability and faster booking experience.</p>

                <hr />

                <h4>2. How We Use Information</h4>
                <ul>
                  <li>Service delivery & booking management</li>
                  <li>Payments processing</li>
                  <li>Customer support</li>
                  <li>Improving app experience</li>
                </ul>

                <hr />

                <h4>3. Data Sharing</h4>
                <p>We do not sell personal data.</p>
                <ul>
                  <li>Service providers (for completing jobs)</li>
                  <li>Payment gateways</li>
                  <li>Legal authorities (if required)</li>
                </ul>

                <hr />

                <h4>4. Payments</h4>
                <p>We do not store card/banking details. Payments are handled by secure third-party providers.</p>

                <hr />

                <h4>5. Data Security</h4>
                <p>We use reasonable safeguards but cannot guarantee 100% security.</p>

                <hr />

                <h4>6. Your Rights</h4>
                <ul>
                  <li>Access your data</li>
                  <li>Collect your data</li>
                  <li>Request deletion</li>
                </ul>

                <hr />

                <h4>7. Contact Us</h4>
                <p><b>Email:</b> Sweeepydo@gmail.com</p>
                <p>
                  <b>Address:</b> Vinayak Vrindavan Tower, Civil Lines, Prayagraj 211001
                </p>

              </div>

            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default PrivacyPolicy;